module.exports = __webpack_public_path__ + "static/img/references-plus.c05e11c0.svg";